import { render, staticRenderFns } from "./Tab-Switcher.vue?vue&type=template&id=2c4462ef&"
import script from "./Tab-Switcher.vue?vue&type=script&lang=ts&"
export * from "./Tab-Switcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports